import { Alert, AlertTitle } from "ra-friendsofbabba";
import { Typography } from "@material-ui/core";
import {
  DebouncedTextInput,
  Group,
  GroupItem,
  useFieldLabel,
} from "ra-friendsofbabba";
import React, { useMemo, useState } from "react";
import { useMutation, useNotify, usePermissions } from "react-admin";

import { useFormState } from "react-final-form";
import ConfirmButton from "../buttons/ConfirmButton";

const CupCodeInput = ({ ...props }) => {
  const fieldLabel = useFieldLabel(props);
  const { record } = props;
  const [confirmed, setConfirmed] = useState(false);
  const notify = useNotify();
  const formState = useFormState();
  const { permissions, loaded } = usePermissions();

  const { disabled, draft, emptyValue } = useMemo(() => {
    const cupCode = record?.cup_code;
    const state =
      formState?.values.transaction?.state || formState?.values?.state;
    const disabled =
      cupCode &&
      cupCode !== null &&
      cupCode?.length > 0 &&
      loaded &&
      !permissions(["admin", "region"]);

    return {
      disabled,
      draft: state === "draft",
      emptyValue:
        formState.values?.cup_code === null ||
        formState.values?.cup_code?.length < 3,
    };
  }, [record, formState.values, loaded, permissions]);
  const [confirm, { loading }] = useMutation(
    {
      type: "post",
      resource: "projects/confirm-cup-code",
      payload: {
        id: record.id,
        cup_code: formState.values?.cup_code,
      },
    },
    {
      onSuccess: () => {
        if (loaded && !permissions(["admin", "region"])) {
          setConfirmed(true);
        }
        notify("resources.projects.notification.cup_code_confirmed", "info");
      },
    }
  );
  return (
    <Group wrapper>
      {!disabled && !draft && (
        <Group>
          {!confirmed && (
            <GroupItem lg={12} md={12}>
              <Alert severity="warning">
                <AlertTitle>Conferma Codice CUP</AlertTitle>
                <Typography variant="body2">
                  <b>Attenzione:</b>il tasto <b>Conferma</b> si abilita dopo
                  aver inserito il codice CUP. La conferma del codice CUP è
                  un'operazione non reversibile, pertanto assicurarsi di averlo
                  inserito correttamente.
                </Typography>
              </Alert>
            </GroupItem>
          )}
        </Group>
      )}

      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <DebouncedTextInput
            source={props.source}
            maxLength={50}
            label={fieldLabel("cup_code")}
            helperText="resources.projects.fields.cup_code.help"
            disabled={(loading || disabled || confirmed) && !draft}
          />
        </GroupItem>
        <GroupItem lg={2} md={2} sm={3} xs={6}>
          {!disabled && !confirmed && !draft && (
            <ConfirmButton
              disabled={loading || confirmed || emptyValue}
              onClick={confirm}
            />
          )}
        </GroupItem>
      </Group>
    </Group>
  );
};
export default CupCodeInput;
